<script lang="ts">
	import bioPhoto1 from "@assets/images/banner/1.jpg?format=webp&w=512&imagetools";
	import bioPhoto2 from "@assets/images/banner/2.jpg?format=webp&w=512&imagetools";
	import decorationRounded from "@assets/images/deco/decoration - rounded.svg";
</script>

<section class="flex flex-col justify-center items-center gap-8 sm:gap-12 md:gap-16 overflow-x-clip full-width">
	<div class="flex flex-col items-center gap-6 sm:gap-8 md:gap-12 w-full container-center px-4 xl:px-0">
		<h1 class="">O nás</h1>

		<div class="relative w-full h-64 xs:h-72 sm:h-80 md:h-[22rem] lg:h-[26rem]">
			<img
				src={decorationRounded}
				alt=""
				class="absolute inset-0 w-full h-full object-contain pointer-events-none -z-10 scale-[2] xs:scale-[2.25] sm:scale-[2.5] md:scale-[3] lg:scale-[3.5]"
			/>

			<div class="relative w-full h-full flex items-center justify-center">
				<div
					class="absolute w-36 h-36 xs:w-40 xs:h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 rounded-full overflow-hidden shadow-xl ring-4 ring-ivory-100 -translate-x-[35%] xs:-translate-x-[35%] sm:-translate-x-[35%]"
				>
					<img src={bioPhoto1} alt="Nikita Szulcsánová" class="w-full h-full object-cover" />
				</div>

				<div
					class="absolute w-36 h-36 xs:w-40 xs:h-40 sm:w-48 sm:h-48 md:w-56 md:h-56 lg:w-64 lg:h-64 translate-x-[35%] xs:translate-x-[35%] sm:translate-x-[35%] z-10"
				>
					<div
						class="w-full h-full rounded-full overflow-hidden shadow-xl"
						style="-webkit-mask-image: linear-gradient(to right, transparent 0%, black 15%); mask-image: linear-gradient(to right, transparent 0%, black 15%);"
					>
						<img src={bioPhoto2} alt="Markéta Farniková" class="w-full h-full object-cover" />
					</div>
					<div
						class="absolute inset-[-4px] rounded-full border-4 border-ivory-100 pointer-events-none"
						style="clip-path: polygon(16% 0%, 100% 0%, 100% 100%, 16% 100%);"
					></div>
				</div>
			</div>
		</div>

		<div class="flex flex-col items-start gap-6 sm:gap-8 md:gap-12 w-full max-w-[55rem]">
			<!-- Nikita -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="font-poppins text-lg sm:text-xl md:text-2xl font-semibold text-midnight text-center">
					Nikita Szulcsánová
				</h2>
				<div class="flex flex-col gap-3 sm:gap-4">
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						Jmenuji se Nikita Szulcsánová (můžeš mi říkat Nikit) a považuji se za akčního člověka, který ale taky
						potřebuje hodně odpočinku, aby byla moje rovnováha zachována. Lidi mi často říkají, že mám v sobě vnitřní
						klid – a právě toho využívám při práci s klienty.
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						Nikdy by mě nenapadlo, že se dá vydělávat klidným a lidským přístupem – ale když jsem objevila trend head
						spa, došlo mi, že by to jít mohlo. Celé to začalo snem, nespočtem kurzů, papírováním a šileným nakupováním
						všeho potřebného pro otevření salonu. Co mě ale doopravdy udrželo, byla možnost přetvořit trend v osobní
						rituál, který odráží mou energii, nápady a zmiňovaný vnitřní klid.
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						Každou procedurou se snažím předat kousek ze sebe, ze svých nápadů a své energie – aby sis odnesl nejen
						krásné a zdravé vlasy, ale i pocit skutečné pohody.
					</p>
				</div>
			</div>

			<!-- Markéta -->
			<div class="flex flex-col gap-3 sm:gap-4 md:gap-5 w-full">
				<h2 class="font-poppins text-lg sm:text-xl md:text-2xl font-semibold text-midnight text-center">
					Markéta Farniková
				</h2>
				<div class="flex flex-col gap-3 sm:gap-4">
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						Jmenuji se Markéta Farniková (můžeš mi říkat Markét) a jsem vyučená kadeřnice s kurzem kosmetiky. Naučila
						jsem se spoustu dovedností, ale naplnění z práce nepřicházelo. Jakmile jsem objevila head spa napohodu, vše
						to změnilo.
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						Při práci teď můžu pečovat o druhé a zároveň jsem zjistila, že co do procedury dám, to se mi taky vrací.
						Práce je najednou radost a zároveň malá forma odpočinku pro mě samotnou.
					</p>
					<p class="font-inter text-xs sm:text-sm md:text-base lg:text-p font-medium leading-[140%] text-midnight">
						Spojením péče, empatie a klidu ti nabízím rituál pohody v propojení se vším, co jsem se naučila o vlasech a
						o pokožce.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
